<ng-container *ngIf="unsupportedBrowser()">
  <py-alert-message
    [title]="'errors.unsupportedBrowser_title' | cxTranslate"
    [body]="'errors.unsupportedBrowser_text' | cxTranslate"
    type="warning"
    [dismissable]="false"
  ></py-alert-message>
</ng-container>
